export default __webpack_public_path__ + "static/media/area3.39ddd275.svg";